import CookieUtils from 'utils/CookieUtils'
import conf from 'conf'

function hasWebConsent() {
  try {
    const raw = CookieUtils.getCookie('gdpr_settings')
    if (!raw || typeof raw !== 'string') return false
    const gdprSettings = raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)

    return gdprSettings.includes('web') || gdprSettings.includes('adv')
  } catch {
    return false
  }
}

function ensureQueue() {
  if (typeof window === 'undefined') return false
  if (!Array.isArray(window.ScarabQueue)) {
    window.ScarabQueue = []
  }
  return true
}

function canTrack() {
  return hasWebConsent() && ensureQueue()
}

export function setSAPEmail(email) {
  if (!canTrack() || !email) return false
  window.ScarabQueue.push(['setEmail', email])
  window.ScarabQueue.push(['go'])
  return true
}

export function setSAPId(id) {
  if (!canTrack() || !id) return false
  window.ScarabQueue.push(['setCustomerId', id])
  window.ScarabQueue.push(['go'])
  return true
}

export function setSAPLink(value) {
  if (!hasWebConsent()) return false

  try {
    window.WebEmarsysSdk.login({
      fieldId: conf.sapLoginFieldID,
      fieldValue: value
    }).then((ok) => {
      console.log('SAP link result:', ok)
    })
  } catch (e) {
    console.error('SAP link error:', e)
    return false
  }
}
